import { Component } from '@angular/core';

@Component({
    // tslint:disable-next-line:component-selector
    selector: '[gbc-text-button]',
    templateUrl: './text-button.component.html',
    styleUrls: ['./text-button.component.scss'],
})
export class TextButtonComponent {
  constructor() {}
}
